import { SelectField, TextField } from './fields';
import { CUSTOM_ROLE, PROFESSIONAL_ROLES, RoleChoice } from './onboarding-model';

const ROLE_OPTIONS = [...PROFESSIONAL_ROLES, CUSTOM_ROLE].map((role) => ({ value: role, label: role }));

/** A trusted professional's role: a listed one, or Custom with a text box for the role. */
export const ProfessionalRoleFields = ({
    value,
    onChange,
    disabled,
}: {
    value: RoleChoice;
    onChange: (value: RoleChoice) => void;
    disabled?: boolean;
}) => (
    <>
        <SelectField
            label="Role"
            value={value.role}
            onChange={(role) => onChange({ ...value, role })}
            options={ROLE_OPTIONS}
            required
            disabled={disabled}
        />
        {value.role === CUSTOM_ROLE && (
            <TextField
                label="Custom role"
                value={value.customRole}
                onChange={(customRole) => onChange({ ...value, customRole })}
                placeholder="Financial planner"
                required
                disabled={disabled}
            />
        )}
    </>
);
